export enum ERpGameStatus {
  CREATED = 1, // Игра создана
  ACTIVE, // В процессе
  FINISHED, // Завершена
  DELETED, // Удалена
}

export const rpGameStatuses: Record<ERpGameStatus, string> = {
  [ERpGameStatus.CREATED]: 'Игра создана',
  [ERpGameStatus.ACTIVE]: 'В процессе',
  [ERpGameStatus.FINISHED]: 'Завершена',
  [ERpGameStatus.DELETED]: 'Удалена',
}
